import { type ReactNode } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export function TitleSectionContainer({ children }: { children: ReactNode }) {
  return (
    <div
      className={twMerge(
        clsx(
          "w-full border-b border-v2-secondary p-0",
          "gap-1 text-left flex flex-col items-start self-stretch",
        ),
      )}
    >
      {children}
    </div>
  );
}
